import api from "./AxiosInterceptor";
import {} from "./CommonServices";
import EndpointService from "./EndpointService";

export const postVerifyProviderDetailsService = async (payload) => {
  const url = EndpointService("verifyProviderDetails");
  const response = await api.post(url, payload);
  return response;
};

export const getProviderService = async (payload) => {
  const url = EndpointService("getProvider").replace(
    "{userInvitationId}",
    payload
  );
  const response = await api.get(url);
  return response;
};

export const postProviderPasswordService = async (data, action) => {
  const url = EndpointService("password").replace("{action}", action);
  const response = await api.post(url, data);
  return response;
};

export const postProviderUsernameService = async (data, action) => {
  const url = EndpointService("username").replace("{action}", action);
  const response = await api.post(url, data);
  return response;
};

export const postProviderCreateAccountService = async (data) => {
  const url = EndpointService("createAccount");
  const response = await api.post(url, data);
  return response;
};

export const postProviderOTPService = async (data, accountType) => {
  const url = EndpointService("account").replace(
    "{fpactusertype}",
    accountType
  );
  const response = await api.post(url, data);
  return response;
};
